module.exports = __webpack_public_path__ + "img/21.da5d1612.png";